import React from 'react';

import underwhelmingGentsUtil from "../lib/underwhelmingGentsUtil";
import { useOutletContext } from 'react-router-dom';

const DraftPicks = ({ outgoingPicks }) => {
    const { managerName } = useOutletContext();
    const draftPicksByYear = underwhelmingGentsUtil.getAllPicks(outgoingPicks, managerName);
    return (
        <div id="draft-picks">
            <h3>Draft Picks</h3>
            <div>
                {Object.keys(draftPicksByYear).map(year => (
                    <div key={year + 'draft'}>
                        <h3>{year} Draft</h3>
                        <div>
                            {draftPicksByYear[year].map((round, index) => (
                                <div key={index + 'round'}>
                                    <div>
                                        <small className="form-text text-muted">Round {index + 1}: {round.map(pick => pick).join(', ')}</small>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
export default DraftPicks;